/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0MachineUsageCompanyCompanyIdGet$Json } from '../fn/machine-usage/api-v-0-machine-usage-company-company-id-get-json';
import { ApiV0MachineUsageCompanyCompanyIdGet$Json$Params } from '../fn/machine-usage/api-v-0-machine-usage-company-company-id-get-json';
import { apiV0MachineUsageCompanyCompanyIdGet$Plain } from '../fn/machine-usage/api-v-0-machine-usage-company-company-id-get-plain';
import { ApiV0MachineUsageCompanyCompanyIdGet$Plain$Params } from '../fn/machine-usage/api-v-0-machine-usage-company-company-id-get-plain';
import { MachineUsageV2 } from '../models/machine-usage-v-2';

@Injectable({ providedIn: 'root' })
export class MachineUsageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0MachineUsageCompanyCompanyIdGet()` */
  static readonly ApiV0MachineUsageCompanyCompanyIdGetPath = '/api/v0/machine-usage/company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineUsageCompanyCompanyIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineUsageCompanyCompanyIdGet$Plain$Response(params: ApiV0MachineUsageCompanyCompanyIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineUsageV2>>> {
    const obs = apiV0MachineUsageCompanyCompanyIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineUsageCompanyCompanyIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineUsageCompanyCompanyIdGet$Plain(params: ApiV0MachineUsageCompanyCompanyIdGet$Plain$Params, context?: HttpContext): Observable<Array<MachineUsageV2>> {
    const resp = this.apiV0MachineUsageCompanyCompanyIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MachineUsageV2>>): Array<MachineUsageV2> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MachineUsageCompanyCompanyIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineUsageCompanyCompanyIdGet$Json$Response(params: ApiV0MachineUsageCompanyCompanyIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineUsageV2>>> {
    const obs = apiV0MachineUsageCompanyCompanyIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MachineUsageCompanyCompanyIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MachineUsageCompanyCompanyIdGet$Json(params: ApiV0MachineUsageCompanyCompanyIdGet$Json$Params, context?: HttpContext): Observable<Array<MachineUsageV2>> {
    const resp = this.apiV0MachineUsageCompanyCompanyIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MachineUsageV2>>): Array<MachineUsageV2> => r.body)
    );
  }

}
